import { render, staticRenderFns } from "./CompanyGroupAdd.vue?vue&type=template&id=a4904b5c&"
import script from "./CompanyGroupAdd.vue?vue&type=script&lang=js&"
export * from "./CompanyGroupAdd.vue?vue&type=script&lang=js&"
import style0 from "./CompanyGroupAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports